import { render } from "./SelectorOpciones.vue?vue&type=template&id=18af5792&scoped=true"
import script from "./SelectorOpciones.vue?vue&type=script&lang=js"
export * from "./SelectorOpciones.vue?vue&type=script&lang=js"

import "./SelectorOpciones.vue?vue&type=style&index=0&id=18af5792&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18af5792"]])

export default __exports__